import { render } from "./ShowAspects.vue?vue&type=template&id=83b49f2e&scoped=true"
import script from "./ShowAspects.vue?vue&type=script&lang=js"
export * from "./ShowAspects.vue?vue&type=script&lang=js"

import "./ShowAspects.vue?vue&type=style&index=0&id=83b49f2e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b49f2e"]])

export default __exports__